// Mock data for photo booth website

export const packages = [
  {
    id: 'bronze',
    name: 'Bronze',
    duration: 3,
    basePrice: 300,
    description: '3 hours of photobooth fun',
    popular: false
  },
  {
    id: 'silver',
    name: 'Silver',
    duration: 4,
    basePrice: 380,
    description: '4 hours of photobooth fun',
    popular: true
  },
  {
    id: 'gold',
    name: 'Gold',
    duration: 5,
    basePrice: 450,
    description: '5 hours of photobooth fun',
    popular: false
  },
  {
    id: 'corporate',
    name: 'Corporate',
    duration: 0,
    basePrice: 0,
    description: 'Price on application',
    popular: false,
    isPOA: true
  }
];

export const features = [
  'Unlimited captures',
  'Boomerang capture',
  'GIF capture',
  'Choice of backdrop',
  'Basic props',
  'Booth attendant(s)',
  'Instant delivery via email, text and/or AirDrop',
  'Custom photo branding',
  'Colour filters',
  'Digital masks'
];

export const addOns = [
  {
    id: 'extra-hour',
    name: 'Additional Hour',
    price: 80,
    description: 'Extend your photobooth experience'
  },
  {
    id: 'premium-backdrop',
    name: 'Backdrop',
    price: 160,
    description: 'Premium backdrop'
  },
  {
    id: 'unlimited-prints',
    name: 'Unlimited Prints',
    price: 120,
    description: 'Unlimited physical photo prints'
  },
  {
    id: 'vinyl-wrap',
    name: 'Custom Vinyl Wrap',
    price: 100,
    description: 'Personalized booth branding'
  }
];

// Note: Discounts available for weekday bookings and charity events
// Standard hourly rate: £95 per hour

export const bookedDates = [
  '2025-08-15',
  '2025-08-16',
  '2025-08-23',
  '2025-08-30',
  '2025-09-06',
  '2025-09-13'
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah & James',
    event: 'Wedding - London',
    rating: 5,
    text: 'The photo booth was the highlight of our wedding! Guests loved it and we got amazing photos.'
  },
  {
    id: 2,
    name: 'Corporate Events Ltd',
    event: 'Company Party - Hertfordshire',
    rating: 5,
    text: 'Professional service, amazing quality. The team made our event unforgettable!'
  },
  {
    id: 3,
    name: 'Emma',
    event: 'Birthday Party - London',
    rating: 5,
    text: 'So much fun! The props were great and the instant sharing was perfect for social media.'
  }
];

export const faqs = [
  {
    question: 'How much space do you need?',
    answer: 'We need approximately 8ft x 8ft of space for our standard booth setup. We can adapt to smaller spaces if needed.'
  },
  {
    question: 'Do you provide props?',
    answer: 'Yes! All packages include a selection of fun props. We can also source custom props for themed events.'
  },
  {
    question: 'How do guests receive their photos?',
    answer: 'Photos are delivered instantly via email, text message, or AirDrop. Guests can share directly to social media.'
  },
  {
    question: 'What areas do you cover?',
    answer: 'We primarily cover London and Hertfordshire. Contact us for events outside these areas.'
  },
  {
    question: 'Can we customize the photo branding?',
    answer: 'Absolutely! All packages include custom photo branding with your event details, logos, or hashtags.'
  },
  {
    question: 'What happens if we need to cancel?',
    answer: 'We offer flexible cancellation policies. Contact us to discuss your specific circumstances.'
  }
];